import { getDetailPost } from '@utils/xhrApi';
import { useSelector } from 'react-redux';
import { useEffect, useCallback, useMemo, useState } from 'react';
import { I_Post } from '../types';
import {
  selectListPostUsedOnTour,
  selectLanguageProjectSelected,
} from '../selectors';

interface Props {
  idPost?: string;
}

export const useGetDetailPost = ({ idPost = '' }: Props) => {
  const listPostUsedOnTour = useSelector(selectListPostUsedOnTour);
  const languageProjectSelected = useSelector(selectLanguageProjectSelected);

  const [loading, setLoading] = useState(false);
  const [detailPost, setDetailPost] = useState<I_Post | undefined>(undefined);

  const onGetDetailPost = useCallback(async () => {
    setLoading(true);
    try {
      let post = listPostUsedOnTour.find(item => item.id === idPost);
      if (!post) {
        const { data } = await getDetailPost(idPost);
        post = data.data;
      }
      setDetailPost(post);
    } catch (err) {
      console.log(err);
      setDetailPost(undefined);
    } finally {
      setLoading(false);
    }
  }, [idPost, listPostUsedOnTour]);

  useEffect(() => {
    if (idPost) onGetDetailPost();
    else setDetailPost(undefined);
    return () => {
      setLoading(false);
      setDetailPost(undefined);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idPost, languageProjectSelected]);

  return useMemo(
    () => ({ loading, detailPost, onGetDetailPost }),
    [loading, detailPost, onGetDetailPost],
  );
};
